function isPlainObject(value) {
    if (value === null || typeof value !== 'object')
        return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
/**
 * Returns `next`, but with every subtree that is deeply equal to the matching subtree of
 * `previous` replaced by the `previous` reference. Playback rebuilds patched subtrees on
 * every animation frame, so this keeps unchanged parts identity-stable for memoized consumers.
 * Only plain objects and arrays are compared structurally; everything else compares by identity.
 */
export function shareStructure(previous, next) {
    if (Object.is(previous, next))
        return previous;
    if (Array.isArray(previous) && Array.isArray(next)) {
        let allShared = previous.length === next.length;
        let out;
        next.forEach((value, index) => {
            const shared = shareStructure(previous[index], value);
            if (shared !== previous[index])
                allShared = false;
            if (shared !== value) {
                out ??= next.slice();
                out[index] = shared;
            }
        });
        return (allShared ? previous : out ?? next);
    }
    if (isPlainObject(previous) && isPlainObject(next)) {
        const nextKeys = Object.keys(next);
        let allShared = nextKeys.length === Object.keys(previous).length;
        let out;
        for (const key of nextKeys) {
            const previousValue = Object.prototype.hasOwnProperty.call(previous, key) ? previous[key] : undefined;
            const shared = shareStructure(previousValue, next[key]);
            if (!Object.prototype.hasOwnProperty.call(previous, key) || shared !== previousValue)
                allShared = false;
            if (shared !== next[key]) {
                out ??= { ...next };
                out[key] = shared;
            }
        }
        return (allShared ? previous : out ?? next);
    }
    return next;
}
